// import dayjs from "dayjs";
export type ITill = {
    name: string;
    id: number;
    postCode: string;
    phone: string;    
    email: string;    
    date: Date;
    status: TillOrderStatus | null;
    pickupDate: Date | null;
    pickupTime: string | null;
  };

export type ITillRecordsSchema = {
    date: Date,
    order: string
}

export type statusOptionsProps = {
    label: string;
    value: TillOrderStatus;
  };

export enum TillOrderStatus {
    PENDING = "pending",
    PARTIAL = "partial",
    PAID = "paid",
    REFUNDED = "refunded",
  }